import { batchServiceBaseUrl } from "services/http";
import { downloadCsv } from './../../../../../../redux/batch/batch-actions';

export const batchServiceEndpoints = {
  // all the existing endpoints of this service are migrated to testSchedule service
}